import { useBreakpointMatch } from "@workflows/ui";
export const useIntakeBreakpoint = (): string => {
  const {
    width
  } = (useBreakpointMatch({
    width: {
      xs: "small",
      sm: "small",
      md: "medium",
      lg: "large",
      xl: "large"
    }
  }) as {
    width: "small" | "medium" | "large" | undefined;
  });
  return width ? width : "large";
};